import { Component, OnInit, HostListener } from '@angular/core';
import { PharmacyPeekService } from '../../services/pharmacy-peek.service';
import { AuthService } from '../../../../auth/auth.service';
import { PouchCountChartData } from '../../models/pouch-count-chart-data';
import { DatePipe } from '@angular/common';
import { ViewStoreService } from '../../services/view-type.service';
import { Store } from '@ngrx/store';
import { State } from 'src/app/store/state';
import { PharmacyPeekWidgetActions } from 'src/app/store/actions';
import { MatDialog } from '@angular/material/dialog';
import { PharmacyPeekMgmtDialogComponent } from '../widgets-configuration/pharmacy-peek-mgmt-dialog/pharmacy-peek-mgmt-dialog.component';
import { getAssetsByOrgID } from 'src/app/store/selectors/assets.selector';
import { PharmacyPeekMgmtDialogMobileComponent } from '../widgets-configuration/pharmacy-peek-mgmt-dialog-mobile/pharmacy-peek-mgmt-dialog-mobile.component';

import { LoggerService } from 'src/app/shared/services/logger.service';
import { getSelectedWidgetsList } from 'src/app/store/selectors/pharmacy-peek-widgets.selector';
import { reconcileWidgetsForActiveDevices } from '../../services/widget-reconcile';

@Component({
    selector: 'app-pharmacy-peek',
    templateUrl: './pharmacy-peek.component.html',
    styleUrls: ['./pharmacy-peek.component.scss'],
    providers: [DatePipe],
    standalone: false
})
export class PharmacyPeekComponent implements OnInit {
  showText: boolean;
  avgHoursToday: number;
  avgHoursTodayHidden: number;
  hourCountHidden: [];
  pouchCountDataToday: PouchCountChartData[] = [];
  dailyPackagerUtilization: { [key: string]: any } = null;
  childOrg = '';
  parentOrg = '';
  orgType: string;
  childOrgId = '';
  todayViewExpandStatus = {
    overview: true,
    atp001: true,
  };

  dataSource: any[];
  pgAssets = [];
  dispenseRatioRowCount = 3;
  displayedColumns: string[] = ['canisterRatio', 'trayRatio', 'deviceId'];
  noDataExistsForHPC = true;
  noDataExistsForDR = true;
  pharmacyWidgetList: any[];
  rawWidgetList: any[] | undefined;
  activeDeviceIds: string[] = [];
  assetsLoaded = false;
  selectedList: any[];
  isLoadedWidget = false;
  constructor(
    public pharmacyPeekService: PharmacyPeekService,
    public auth: AuthService,
    public viewStoreService: ViewStoreService,
    private loggerService: LoggerService,
    public dialog: MatDialog,
    private store: Store<State>,
  ) { }

  ngOnInit() {
    this.isLoadedWidget = false;
    //To load PP based configured widgets
    this.LoadPPWidgets();

    this.auth.profile$.subscribe(async profile => {
      this.parentOrg = profile.parentOrganization;
      this.childOrg = profile.organization;
      this.childOrgId = profile.organizationId;
      this.orgType = profile.orgType;
    });

    this.store.select(getAssetsByOrgID).subscribe(assets => {
      if (assets) {
        this.pgAssets = [];
        this.activeDeviceIds = [];
        assets.forEach(element => {
          this.pgAssets.push({ deviceId: element.machineNo, deviceName: element.name });
          this.activeDeviceIds.push(String(element.machineNo));
        });
        this.assetsLoaded = true;
        this.reconcileWidgets();
      }
    }
    );

    this.store.select(getSelectedWidgetsList).subscribe(res => {
      if (res) {
        this.rawWidgetList = res;
        this.reconcileWidgets();
      }
    });
  }

  /**
   * Removes widgets whose configured device is no longer active.
   * Render-only: it never writes the cleaned config back to the store/API.
   * Until active devices are known, the saved config is rendered as-is.
   */
  private reconcileWidgets() {
    if (!this.rawWidgetList) {
      return;
    }
    if (!this.assetsLoaded) {
      this.pharmacyWidgetList = this.rawWidgetList;
      return;
    }
    this.pharmacyWidgetList = reconcileWidgetsForActiveDevices(this.rawWidgetList, this.activeDeviceIds);
  }

  private LoadPPWidgets() {
    this.pharmacyPeekService.getUserConfiguration().subscribe(
      (response) => {
        this.store.dispatch(PharmacyPeekWidgetActions.getSelectedPharmacyWidgetList({ data: response }));
      },
      (error) => {
        if (error.status === 404) {
          console.log('getUserConfiguration Service error: No Data', error);
        } else {
          this.loggerService.logError('getUserConfiguration Service: Error: ', error);
        }
      },
    )
  }

  openPharmacyPeekMgmtDialog() {
    const dialogRef = this.dialog.open(PharmacyPeekMgmtDialogComponent, { backdropClass: 'lgDialog',  disableClose: true });

    dialogRef.afterClosed().subscribe(result => {
      console.log(`Dialog result: ${result}`);
      this.isLoadedWidget = false;
    });
  }

  openPharmacyPeekMgmtDialogMobile() {
    const dialogRef = this.dialog.open(PharmacyPeekMgmtDialogMobileComponent, { backdropClass: 'lgDialog',  disableClose: true });

    dialogRef.afterClosed().subscribe(result => {
      console.log(`Dialog result: ${result}`);
      this.isLoadedWidget = false;
    });

  }
  @HostListener('window:keyup.esc') close(): void {
    document.getElementsByClassName("animate__animated")[0].classList.remove("animate__slideInLeft")
    document.getElementsByClassName("animate__animated")[0].classList.add("animate__slideOutRight");
    setTimeout(() => { this.dialog.closeAll(); }, 1000);
  }
}
